import { useQueryCountries } from '@/modules/shared/query-client/useQueryCountries'
import { parseChartIso } from '@/modules/imports/components/TachographChartCanvas'
import { ChartEditor } from './useChartEditor'
import { useVehicleLabels } from './useVehicleLabels'
import { fmt, useChartT } from '../i18n'

// Canvas angles use clock minutes from midnight, not elapsed time from day start.
function clockMinute(iso: string): number {
  const date = parseChartIso(iso)
  return date.getUTCHours() * 60 + date.getUTCMinutes()
}

export function useChartMarkers(companyId: string, editor: ChartEditor) {
  const T = useChartT()
  const { data: countries } = useQueryCountries({ companyId })
  const vehicleLabels = useVehicleLabels(companyId)
  return {
    vehicleChangeMinutes: editor.additionalVehiclesUsed.map((v) =>
      clockMinute(v.startTime),
    ),
    vehicleChanges: editor.additionalVehiclesUsed.map((v) => ({
      id: v.vehiclesUsedId,
      minute: clockMinute(v.startTime),
      label: fmt(
        T('vehicleChangeTooltip', 'Zmiana pojazdu na {0}, licznik początkowy {1}, licznik końcowy {2}.'),
        (v.vehicleId != null && vehicleLabels.get(v.vehicleId)) || '–',
        v.odometerStart,
        v.odometerEnd,
      ),
    })),
    vehicleLabels,
    countryChanges: editor.countryChanges.map((c) => ({
      minute: clockMinute(c.atTime),
      code: c.country,
    })),
    beginCountryCode: countries?.find((c) => c.nationId === editor.beginCountry)
      ?.code,
    endCountryCode: countries?.find((c) => c.nationId === editor.endCountry)
      ?.code,
  }
}
